/**
 * 新疆舆情历史热点管理
 * 2018-01-16
 * by 于再洋
 */
"use strict";
angular.module("historyHotAdminModule", [
    "historyHotAdminServiceMoudle" //服务
]).
controller("historyHotAdminCtrl", ["$scope", "trsHttpService", "historyHotAdminService", function($scope, trsHttpService, historyHotAdminService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            saveright:false,//保存提示
            saveerr:false,//错误提示
            prompt:false,//提示
            page: {
                CURRPAGE: 1,
                PAGESIZE: 10,
                ITEMCOUNT: '',
                PAGECOUNT: '',
                copyCurrPage: 1,
            }
        };
        $scope.data = {
            searchWord:'',
        };
    }

    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
         requestData();
    }

    /**
     * [searchData description] 搜索
     * @return {[type]} [description]
     */
    $scope.searchData = function() {
         requestData();
    }
    /**
     * [searchData description] 搜索
     * @return {[type]} [description]
     */
    function requestData() {
        $scope.params = {
             "typeid": 'screen',
             "serviceid": 'zjsentimentrulemgr',
             "modelid": 'getrulelist',
             "type":'1',
             "search_word":$scope.data.searchWord,
             "page_size": $scope.status.page.PAGESIZE,
             "page_no": $scope.status.page.copyCurrPage - 1
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
            $scope.status.page.PAGECOUNT = data.totalPages;
            $scope.status.page.ITEMCOUNT = data.totalElements;
            var newsList = [];
            if(data.content){
                for (var i = 0; i < data.content.length; i ++) {
                    newsList.push(data.content[i]);
                }
            }
            
            $scope.dataList = angular.copy(newsList);
            for(var i=0;i<$scope.dataList.length;i++ ){
                if($scope.dataList[i].content.length>300){
                    $scope.dataList[i].content = $scope.dataList[i].content.substr(0,300)+"……";
                    $scope.dataList[i].show = true;
                }else{
                    $scope.dataList[i].content = $scope.dataList[i].content;
                    $scope.dataList[i].show = false;
                }
            }
            $scope.newTopicList = newsList;
        });
    }
    /*
     *[pageChanged description:跳转页面]
     */
    $scope.pageChanged = function() {
        $scope.status.page.copyCurrPage = $scope.status.page.CURRPAGE;
        $scope.params.page_no = $scope.status.page.copyCurrPage;
        requestData();
    };
    /*
     *[jumpToPage description:跳转到指定页面]
     */
    $scope.jumpToPage = function() {
        if (!$scope.status.page.copyCurrPage) return;
        if ($scope.status.page.copyCurrPage > $scope.status.page.PAGECOUNT) {
            $scope.status.page.copyCurrPage = $scope.status.page.PAGECOUNT;
        }
        $scope.status.page.CURRPAGE = $scope.status.page.copyCurrPage;
        requestData();
    };
    /**
     * [openCheck description] 查看弹窗
     * @return {[type]} [description]
     */
    $scope.openCheck = function(id) {
        historyHotAdminService.check(id).then( function(data){
            if(data == true){
                setTimeout(function(){
                    requestData();
                },500)
            }
        });
    }
    /**
     * [del description] 删除弹窗
     * @return {[type]} [description]
     */
    $scope.listdel = function(id) {
        historyHotAdminService.del(id).then( function(data){
            if(data == true){
                setTimeout(function(){
                    if($scope.dataList.length == 1){
                        $scope.data.searchWord = "";
                        requestData();
                    }else{
                        requestData();
                    }
                },500)
            }
        });
    }
    /**
     * [editrule description] 编辑弹窗
     * @return {[type]} [description]
     */
    $scope.edithot = function(id) {
        historyHotAdminService.edithot(id).then( function(data){
            if(data == true){
                setTimeout(function(){
                    requestData();
                },500)
            }
        });
    }
    /**
     * [addrule description] 添加弹窗
     * @return {[type]} [description]
     */
    $scope.addhot = function() {
        historyHotAdminService.addhot().then( function(data){
            if(data == true){
                setTimeout(function(){
                    requestData();
                },500)
            }
        });
    }

    /**
     * [help description] 帮助弹窗
     * @return {[type]} [description]
     */
    $scope.help = function() {
        historyHotAdminService.help();
    }
}]);